// Module
var code = `<h1>Display ads</h1> <h3 class="metric-meaning">What does it mean?</h3><p>The traffic sent from other domains via well-known advertising networks, such as Google Ads, Yandex Direct, Skimlinks, etc.</p> `;
// Exports
module.exports = code;